import { useTranslation } from 'next-i18next'
import { useState } from 'react'

import styles from '~/shared/styles/Input.module.css'

import { Icon } from './Icon'

export function InputDashboard({
  autoComplete,
  disabled,
  errorMessage,
  // helperText,
  label,
  name,
  onChange,
  type = 'text',
  value,
}: {
  autoComplete: string
  disabled?: boolean
  errorMessage: string | undefined
  helperText?: string
  label: string
  name: string
  onChange: (val: string) => void
  type: string
  value: string
}): React.ReactElement {
  const [focused, setFocused] = useState(false)
  const { t } = useTranslation('settings')

  const handleOnBlur = (): void => {
    setFocused(false)
  }

  const handleOnFocus = (): void => {
    setFocused(true)
  }

  const hasError = errorMessage?.length

  return (
    <div className="input-wrapper">
      <div className={`${styles['input-container']} ${hasError ? `${styles['--has-error']}` : ''}`}>
        <input
          autoComplete={autoComplete}
          className={`${styles.input} ${value ? `${styles['--has-value']}` : ''} appearance-none`}
          disabled={disabled}
          id={name}
          name={name}
          onBlur={handleOnBlur}
          onChange={(e) => onChange(e.target.value)}
          onFocus={handleOnFocus}
          placeholder={(focused && !value) || hasError ? label : ''}
          type={type}
          value={value}
        />

        <label className={`${styles['input-label']} ${value ? `${styles['--has-value']}` : ''}`} htmlFor={name}>
          {label}
        </label>

        {/* {helperText && !isFieldErrors && (
                <small className="input__helper-text">
                  {helperText}
                </small>
              )} */}
        <Icon
          alt={t('editInputFieldIcon')}
          className={`${styles['input-edit-icon']}`}
          customImageSrc="misc/edit-input-field.svg"
        />
      </div>
      {hasError && (
        <div className="input__error-messages-container">
          <small className={`${styles['input__error-message']}`}>{errorMessage}</small>
        </div>
      )}
    </div>
  )
}
